export const getItemById = <T extends { id: string }>(
  items: T[]
): Record<string, T> => {
  return items.reduce<Record<string, T>>((acc, curr) => {
    acc[curr.id] = curr;
    return acc;
  }, {});
};
